var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconGithub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,0A20,20,0,1,0,40,20,20,20,0,0,0,20,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.12 31.354h-6.052v-3.028c-4.143.892-5.3-2.271-5.3-2.271a9.32 9.32 0 0 0-1.516-2.27c-1.514-.9 0-.756 0-.756a2.8 2.8 0 0 1 2.271 1.514 3.6 3.6 0 0 0 4.541 1.514c-.006-.82.26-1.618.756-2.271-3.306-.372-6.058-2.271-6.058-6.056s.76-4.541 1.517-5.3a4.69 4.69 0 0 1 .023-3.785c0 0 1.487 0 3 2.271.75-.75 3.028-.756 3.785-.756s3.034.006 3.784.756c1.514-2.271 3.006-2.271 3.006-2.271.54 1.202.548 2.576.023 3.785.756.756 1.514 1.514 1.514 5.3s-2.744 5.682-6.052 6.057a4.09 4.09 0 0 1 .756 2.271v5.3z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGithub);
export default __webpack_public_path__ + "static/media/icon_github.0ba727dc2632c2ecbe29079e7abe1699.svg";
export { ForwardRef as ReactComponent };